var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Accordion',{staticClass:"pr-SizeDetailAccordion",scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n    サイズ一覧 (単位: cm)\n  ")]},proxy:true},{key:"content",fn:function(){return [_c('SizeDetail')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }